// @flow
export const TOGGLE_BACKBONE = 'g/ui/TOGGLE_BACKBONE';

export default {
    TOGGLE_BACKBONE,
};
